import { http, HttpResponse } from 'msw';

import { step } from './fixture/requirement';
import { config as facemacthConfig, token as facemacthToken, facematchKey, facematch } from './fixture/facial-biometrics';

export const facialBiometricsHandlers = [
  http.get('**/steps/facial_biometrics', () => HttpResponse.json(step('facial_biometrics'))),
  http.post('**/steps/facial_biometrics/fulfill', () => HttpResponse.json({ data: { facematchKey } })),
  http.get('**/facematches/config', () => HttpResponse.json(facemacthConfig)),
  http.get('**/facematches/:facematchKey/check', () => HttpResponse.json(null)),
  http.get('**/facematches/:facematchKey', () => HttpResponse.json({ facematch })),
  http.get('**/caf/tokens', () => HttpResponse.json(facemacthToken)),
];
